import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { LoadingContext } from './LoadingContext';

export interface LoadingContextProviderProps {}

interface LoadingState {
  [key: string]: boolean;
}

const LoadingContextProvider: React.FC<LoadingContextProviderProps> = ({ children }) => {
  const [state, setState] = useState<LoadingState>({});
  const setLoading = useCallback(
    (key: string, loading: boolean) => setState(prev => ({ ...prev, key: loading })),
    []
  );
  const getLoading = useCallback((key: string) => !!state[key], [state]);
  const value = useMemo(
    () => ({ getLoading, setLoading, loading: Object.values(state).some(v => !!v) }),
    [getLoading, setLoading]
  );
  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

export default LoadingContextProvider;
